import { useState } from "react";
import { Paper, Tab, Tabs } from "@material-ui/core";
import useStyles from "./styles";
import Goals from "./components/Goals";
import PersonalInformation from "./components/PersonalInformation";
import Notes from "./components/Notes";

const TabPanel = (props: any) => {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <div style={{ padding: "20px" }}>{children}</div>}
		</div>
	);
};

export default function ClientTabs() {
	const classes = useStyles();
	const [value, setValue] = useState(
		parseInt(localStorage.getItem("currentTab") ?? "2")
	);

	const handleChange = (event: any, newValue: any) => {
		localStorage.setItem("currentTab", newValue);
		setValue(newValue);
	};

	return (
		<Paper square className={classes.root}>
			<Tabs
				value={value}
				indicatorColor="primary"
				textColor="primary"
				onChange={handleChange}
				variant="scrollable"
				scrollButtons="auto"
				aria-label="disabled tabs example"
			>
				<Tab label="General Information" />
				<Tab label="Treatment Plans" />
				<Tab label="Notes" />
			</Tabs>
			<TabPanel value={value} index={0}>
				<PersonalInformation />
			</TabPanel>
			<TabPanel value={value} index={1}>
				<Goals />
			</TabPanel>
			<TabPanel value={value} index={2}>
				<Notes />
			</TabPanel>
		</Paper>
	);
}
